import { render } from "./review-table.vue?vue&type=template&id=24a4165a"
import script from "./review-table.vue?vue&type=script&lang=js"
export * from "./review-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__